import React from "react";

export const CreateCanvasIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M4.5 4H15c.398 0 .78.193 1.06.537.282.344.44.81.44 1.296v7.334c0 .486-.158.952-.44 1.296-.28.344-.662.537-1.06.537H4.5c-.398 0-.78-.193-1.06-.537A2.06 2.06 0 0 1 3 13.167V5.833c0-.486.158-.952.44-1.296C3.72 4.193 4.101 4 4.5 4"
      ></path>
      <path stroke="#113357" strokeLinecap="round" strokeWidth="1.2" d="M9.8 7v5M12.3 9.5h-5"></path>
    </svg>
  );
};
